import { InputProps } from 'antd';
import { PasswordProps } from 'antd/es/input/Password';
import { TextAreaProps, TextAreaRef } from 'antd/es/input/TextArea';
import Search from 'antd/es/input/Search';
import Group from 'antd/es/input/Group';

export interface IInputProps extends Omit<InputProps, 'variant'> {
  variant?: InputVariant;
}

export interface IPasswordProps extends Omit<PasswordProps, 'variant'> {
  variant?: InputVariant;
}

export interface ITextAreaProps extends Omit<TextAreaProps, 'variant'> {
  variant?: InputVariant;
}

export enum InputVariant {
  FILLED = 'filled',
  BORDERED = 'bordered',
}

export type CompoundedInputComponent<R, P> = React.ForwardRefExoticComponent<P & React.RefAttributes<R>> & {
  Group: typeof Group;
  Search: typeof Search;
  TextArea: React.ForwardRefExoticComponent<ITextAreaProps & React.RefAttributes<TextAreaRef>>;
  Password: React.ForwardRefExoticComponent<IPasswordProps & React.RefAttributes<R>>;
};
